import * as React from "react";
import { SVGProps } from "react";

const FrontsDropDownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={8} {...props}>
    <path fill="#18b5b7" d="M5.5 0 11 8H0Z" data-name="Polygon 401" />
  </svg>
);
export default FrontsDropDownArrow;
